import { DOM } from './matchMedia/browser';
import Header from '@mands/mns-core-ui-header/dist/templates/header/bundle';
import Footer from '@mands/mns-core-ui-footer/dist/templates/footer/bundle';
import { ViewPort } from './matchMedia';
import '@mands/mns-fe-pattern-library/lib/mns-fe-utilities/lazy-load';
import previewBanner from '@mands/mns-fe-pattern-library/lib/mns-fe-utilities/preview-banner';
/* istanbul ignore file */
DOM.ready(() => {
    Header.Top();
    Header.Navigation();
    Footer.Top();
    previewBanner.init();
});

window.getChannelId = function () {
    const viewport = ViewPort.getCurrent();

    const desktop = -1;
    const mobile = -6;

    return viewport === ViewPort.xl ? desktop : mobile;
};

window.hasClass = function (el, className) {
    if (el.classList) {
        return el.classList.contains(className);
    }
    return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
};

window.addClass = function (el, className) {
    if (el.classList) {
        el.classList.add(className);
    } else if (!window.hasClass(el, className)) {
        el.className += ' ' + className;
    }
};


// WEBPACK FOOTER //
// /src/common/common.js